import { get, writable } from "svelte/store";
import { fetchWithSession } from "../util/fetchWithSession.js";

// Entwurf der Sprachmodell-Einstellungen (Admin -> General Settings). Gespeichert wird
// zusammen mit den uebrigen Admin-Schaltern ueber "Save settings". Der Schluessel wird nur
// gesendet, nie zurueckgelesen: leer = gespeicherten Schluessel behalten,
// clear_api_key = loeschen und auf den Plattform-Standard zurueckfallen.
const EMPTY = {
  cloud: true,
  base_url: "",
  model: "",
  local_base_url: "",
  local_model: "",
  company_profile: "",
  api_key: "",
  clear_api_key: false,
  has_api_key: false,
  api_key_hint: "",
  env_api_key: false,
  env_base_url: "",
  effective_local_base_url: "",
};

export const llmSettings = writable({ ...EMPTY });

export async function loadLlmSettings() {
  const response = await fetchWithSession("/api/damprojects/llm-settings");
  if (!response.ok) throw new Error("LLM settings could not be loaded.");
  const data = await response.json();
  llmSettings.set({ ...EMPTY, ...data, api_key: "", clear_api_key: false });
  return get(llmSettings);
}

export async function saveLlmSettings() {
  const draft = get(llmSettings);
  const response = await fetchWithSession("/api/damprojects/llm-settings", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      cloud: draft.cloud,
      base_url: draft.base_url,
      model: draft.model,
      local_base_url: draft.local_base_url,
      local_model: draft.local_model,
      company_profile: draft.company_profile,
      api_key: draft.api_key,
      clear_api_key: draft.clear_api_key,
    }),
  });
  if (!response.ok) throw new Error("LLM settings could not be saved.");
  const data = await response.json();
  llmSettings.set({ ...EMPTY, ...data, api_key: "", clear_api_key: false });
  return get(llmSettings);
}
